import _ from 'lodash';

class Cookies {

    setCookie(cname, cvalue, exdays) {

        var d = new Date(),
        expires;

        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = 'expires=' + d.toUTCString();

        document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';

    }

    getCookie(cname) {
        
        let name = cname + '=',
            ca,
            c;

        ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }

        return '';

    }

    constructor() {

        this.$cookieBar = $('.BannerCookies');
        this.acceptanceCookiesName = 'cookie_policy_accepted';
    
        this.checkAccepted();

    }
    
    checkAccepted() {
        const hasAcceptedCookies = this.getCookie(this.acceptanceCookiesName) !== '';
        
        if (!hasAcceptedCookies) {


            $(window).on('click', () => {
                this.accept();
            });
            
            this.showCookieBar();

            this.$cookieBar.on('click', '.accept', (e) => {

                e.preventDefault();
                this.accept();


            });


        }

    }

    removeCookieBar() {

        if (!this.$cookieBar.length) return false;
        return this.$cookieBar.remove();

    }

    showCookieBar() {

        this.$cookieBar.show();

    }

    accept() {

        this.setCookie(this.acceptanceCookiesName, 'accepted', 365);
        this.removeCookieBar();

    }

}

export default new Cookies();


// WEBPACK FOOTER //
// ./js/components/cookies.js